import React from 'react';

import { RoundedButton } from '@/components/shared/RoundedButton';
import { classNames } from '@/helpers/classNames';
import { SvgIcon } from '@material-ui/core';

import styles from './EmptySetlistCard.module.scss';

type EmptySetlistCardProps = {
	className?: string;
	iconComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
	iconStyle?: React.CSSProperties;
	title?: string;
	subtitle?: string;
	buttonLabel?: string;
	onButtonClick?: () => void;
};

export const EmptySetlistCard: React.FC<EmptySetlistCardProps> = ({
	className,
	iconComponent,
	iconStyle,
	title,
	subtitle,
	buttonLabel,
	onButtonClick,
}) => {
	const classes = classNames([styles['root'], className]);
	return (
		<div className={classes} onClick={onButtonClick}>
			<div className={styles['icon-holder']}>
				<SvgIcon
					component={iconComponent}
					className={styles['icon']}
					style={iconStyle}
				/>
			</div>
			<div className={styles['center-content']}>
				<div className={styles['title']}>{title}</div>
				<div className={styles['subtitle']}>{subtitle}</div>
			</div>
			<div className={styles['button-holder']}>
				<RoundedButton>{buttonLabel}</RoundedButton>
			</div>
		</div>
	);
};
